import { Link } from "react-router-dom";
import { articles } from "@/mocks/gossipData";
import { formatCount } from "@/components/feature/ArticleCard";

interface ArticleTocProps {
  sections: { title: string }[];
  currentId: string;
}

export default function ArticleToc({ sections, currentId }: ArticleTocProps) {
  const hot = [...articles]
    .filter((item) => item.id !== currentId)
    .sort((a, b) => b.readCount - a.readCount)
    .slice(0, 5);

  return (
    <aside className="flex flex-col gap-6 lg:sticky lg:top-28">
      <div className="rounded-xl border border-background-200 bg-background-100 p-5">
        <h2 className="font-heading text-base text-foreground-950">本文目录</h2>
        <nav aria-label="文章目录" className="mt-3">
          <ol className="flex flex-col gap-2.5 text-sm">
            {sections.map((section, index) => (
              <li key={section.title} className="flex gap-2">
                <span className="font-label text-primary-500">{index + 1}.</span>
                <a
                  href={`#section-${index}`}
                  className="text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                >
                  {section.title}
                </a>
              </li>
            ))}
          </ol>
        </nav>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-base text-foreground-950">热门推荐</h2>
        <ol className="mt-4 flex flex-col gap-4">
          {hot.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/gossip/${item.id}`}
                className="group flex gap-3 cursor-pointer"
              >
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 font-label text-xs text-accent-800">
                  {index + 1}
                </span>
                <span className="flex flex-col gap-1">
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line" aria-hidden="true" />
                    {formatCount(item.readCount)}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}